/*
================================================================ 
         Copyright (c) 2018-2021 Digitize Things Inc.           
                     All rights reserved.                       
================================================================ 
*/

import React, { Component } from "react";
import Input from "../../../../component/inputpm";
import Loader from "../../../../component/loader";
import IconButton from "@mui/material/IconButton";
import { connect } from "react-redux";
import actionTypes from "../../../../store/actions";
import BusApiCall from "../../../../helper/axios";
import constants from "../../../../helper/constants";
import SettlementTable from "./settlementTable";
import classes from "../reports.module.css";
import moment from "moment";
import Breadcrumb from "../../../../component/breadcrumb";
import Paper from "@mui/material/Paper";
import TextField from "@mui/material/TextField";
import Tooltip from "@mui/material/Tooltip";
import {
  SearchIcon,
  ClearIcon,
  RefreshIcon,
} from "../../../../component/icons/icons";
import { withTranslation } from "react-i18next";
import { Grid } from "@mui/material";
import dateFormat from "dateformat";

class Settlement extends Component {
  // Declare property values that belongs to the component
  state = {
    tabValue: 0,
    settlementList: [],
    rowsPerPage: 10,
    page: 1,
    startRecord: 1,
    totalSettlementCount: 0,
    sortBy: "createdStamp",
    sortOrder: "DESC",
    customerBan: "",
    customerName: "",
    orderId: "",
    itemDescription: "",
    solutionProviderName: "",

    fromDate: "",
    toDate: "",

    purchasePrice: 0,
    sellingPrice: 0,
    settledAmount: 0,
    bread: [{ title: this.props.t("SETTLEMENT"), url: "/settlement" }],
    today: moment(new Date()).format("yyyy-MM-DD"),
  };

  // Intial HTTP calls or data manipulation on page load
  componentDidMount() {
    this.props.setCompDidMount();
    this.getSettlements();
  }

  getSettlements = () => {
    this.setState({
      loading: true,
    });
    let pageOptions = {
      batchSize: this.state.rowsPerPage,
      startRecord: this.state.startRecord,
    };

    let fromDate = this.state.fromDate
      ? encodeURIComponent(this.convertDateParam(this.state.fromDate))
      : "";
    let toDate = this.state.toDate
      ? encodeURIComponent(this.convertTillDateParam(this.state.toDate))
      : "";

    let searchFilter = `providerName=${this.state.solutionProviderName}&customerBan=${this.state.customerBan}&customerName=${this.state.customerName}&orderId=${this.state.orderId}&productName=${this.state.itemDescription}&from=${fromDate}&to=${toDate}`;
    BusApiCall(
      "GET",
      `${constants.busV4Url}/settlement/views/summary?sortBy=${this.state.sortBy}&sortOrder=${this.state.sortOrder}&${searchFilter}`,
      {},
      pageOptions,
    )
      .then((res) => {
        //let data = JSON.parse(res);
        this.setState({
          settlementList: res.data.settlements,
          totalSettlementCount: +res.headers["x-total-count"],
          loading: false,
        });
      })
      .catch((err) => {
        if (err.response && err.response.data && err.response.data.message) {
          this.props.setErrorMessage(err.response.data.message, false);
        } else {
          this.props.setErrorMessage(
            this.props.t("DEFAULT_ERROR_MESSAGE"),
            false,
          );
        }
        this.setState({ loading: false });
      });
  };

  // convertDate(date) {
  //   return moment(date).format("MM/DD/YYYY, h:mm a");
  // }

  convertDateParam(date) {
    return moment(date).format("yyyy-MM-DDTHH:mm:ss:SSS+00:00");
  }

  convertTillDateParam(date) {
    return moment(date).format("yyyy-MM-DDT23:59:59:999+00:00");
  }

  prependZero(numToChange) {
    var retNum = parseInt(numToChange);
    retNum = retNum < 10 ? "0" + retNum : retNum;
    return retNum;
  }

  isValidDate(dateString) {
    if (!dateString) {
      return true;
    }
    // First check for the pattern
    if (!/^\d{1,2}\/\d{1,2}\/\d{4}$/.test(dateString)) return false;

    // Parse the date parts to integers
    var parts = dateString.split("/");
    var day = parseInt(parts[1], 10);
    var month = parseInt(parts[0], 10);
    var year = parseInt(parts[2], 10);

    // Check the ranges of month and year
    if (year < 1000 || year > 3000 || month == 0 || month > 12) return false;

    var monthLength = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];

    // Adjust for leap years
    if (year % 400 == 0 || (year % 100 != 0 && year % 4 == 0))
      monthLength[1] = 29;

    // Check the range of the day
    return day > 0 && day <= monthLength[month - 1];
  }

  // Change page
  handleChangePage = (event, newPage) => {
    this.setState(
      {
        page: newPage,
        startRecord: this.state.rowsPerPage * (newPage - 1) + 1,
      },
      () => {
        this.getSettlements();
      },
    );
  };

  // Change rows per page
  handleChangeRowsPerPage = (event) => {
    this.setState(
      {
        page: 1,
        rowsPerPage: event.target.value,
        startRecord: 1,
      },
      () => {
        this.getSettlements();
      },
    );
  };

  // Change table sorting
  updateSorting = (by) => {
    if (by === this.state.sortBy) {
      this.setState(
        {
          sortOrder: this.state.sortOrder === "DESC" ? "ASC" : "DESC",
          page: 1,
          startRecord: 1,
        },
        () => {
          this.getSettlements();
        },
      );
    } else {
      this.setState(
        {
          sortBy: by,
          sortOrder: "ASC",
          page: 1,
          startRecord: 1,
        },
        () => {
          this.getSettlements();
        },
      );
    }
  };

  // Update state data on input change
  onChange = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
    });
  };

  // Search/Filter orders
  filterTable = () => {
    this.props.setErrorMessage("", false);
    this.setState(
      {
        page: 1,
        startRecord: 1,
        // customerBan: '',
        // customerName: '',
        // featureCode: '',
        // settlementId: '',
        // itemDescription: '',
      },
      () => {
        this.getSettlements();
      },
    );
  };

  // Clear all search filters
  clearFilters = () => {
    this.props.setErrorMessage("", false);
    this.setState(
      {
        customerBan: "",
        customerName: "",
        orderId: "",
        itemDescription: "",
        solutionProviderName: "",
        fromDate: "",
        toDate: "",
        page: 1,
        startRecord: 1,
      },
      () => {
        this.getSettlements();
      },
    );
  };

  refreshTableSearch = () => {
    this.setState(
      {
        customerBan: "",
        customerName: "",
        orderId: "",
        itemDescription: "",
        solutionProviderName: "",
        fromDate: "",
        toDate: "",
        page: 1,
        startRecord: 1,
      },
      () => {
        this.getSettlements();
      },
    );
  };

  // Search orders on press enter key
  onSearchKeyDown = (e) => {
    if (e.key === "Enter") {
      this.filterTable();
    }
  };

  changeTab = (e, newValue) => {
    this.setState({
      tabValue: newValue,
    });
  };

  // Render order view
  render() {
    const t = this.props.t;
    return (
      <div className={"newContentWrapper"}>
        <div className={"breadcrumbWrapper"}>
          <div className={"breadcrumbContent"}>
            <Grid container>
              <Grid
                item
                size={{
                  xs: 12,
                }}
              >
                <Breadcrumb list={this.state.bread} />
              </Grid>
            </Grid>
          </div>
        </div>
        <main style={{ marginTop: "0px" }}>
          <Paper
            className={"tablePaper"}
            elevation={0}
            style={{ background: "transparent" }}
          >
            <div className={classes.searchOuterDiv}>
              {this.props.providerType === "SALES_CHNL_PROVIDER" && (
                <div>
                  <Input
                    size={"small"}
                    variant={"outlined"}
                    placeholder={t("PROVIDER_NAME")}
                    value={this.state.solutionProviderName}
                    name={"solutionProviderName"}
                    onChange={(e) => {
                      this.onChange(e);
                    }}
                    divClass={classes.inputClass}
                    onKeyDown={(e) => {
                      this.onSearchKeyDown(e);
                    }}
                  />
                </div>
              )}
              <div>
                <Input
                  size={"small"}
                  variant={"outlined"}
                  placeholder={t("PRODUCT_NAME")}
                  value={this.state.itemDescription}
                  name={"itemDescription"}
                  onChange={(e) => {
                    this.onChange(e);
                  }}
                  divClass={classes.inputClass}
                  onKeyDown={(e) => {
                    this.onSearchKeyDown(e);
                  }}
                />
              </div>
              <div>
                <Input
                  size={"small"}
                  variant={"outlined"}
                  placeholder={t("ORDER_ID")}
                  value={this.state.orderId}
                  name={"orderId"}
                  onChange={(e) => {
                    this.onChange(e);
                  }}
                  divClass={classes.ordInputClass}
                  onKeyDown={(e) => {
                    this.onSearchKeyDown(e);
                  }}
                />
              </div>
              <div>
                <Input
                  size={"small"}
                  variant={"outlined"}
                  placeholder={t("CUSTOMER_NAME")}
                  value={this.state.customerName}
                  name={"customerName"}
                  onChange={(e) => {
                    this.onChange(e);
                  }}
                  divClass={classes.inputClass}
                  onKeyDown={(e) => {
                    this.onSearchKeyDown(e);
                  }}
                />
              </div>
              {this.props.providerType === "SALES_CHNL_PROVIDER" && (
                <div>
                  <Input
                    size={"small"}
                    variant={"outlined"}
                    placeholder={t("CUSTOMER_BAN")}
                    value={this.state.customerBan}
                    name={"customerBan"}
                    onChange={(e) => {
                      this.onChange(e);
                    }}
                    divClass={classes.inputClass}
                    onKeyDown={(e) => {
                      this.onSearchKeyDown(e);
                    }}
                  />
                </div>
              )}
              {/* <div>
                            <Input
                                placeholder="Agent Id"
                                value={this.state.agentId}
                                name={"agentId"}
                                onChange={(e) => { this.onChange(e) }}
                                divClass={classes.agInputClass}
                                onKeyDown={(e) => { this.onSearchKeyDown(e) }}
                            />
                        </div> */}
              <div>
                <TextField
                  name="fromDate"
                  id="fromDate"
                  type="date"
                  value={this.state.fromDate}
                  label={t("FROM_DATE")}
                  InputLabelProps={{
                    shrink: true,
                  }}
                  variant={"outlined"}
                  size={"small"}
                  onChange={(e) => {
                    this.onChange(e);
                  }}
                  inputProps={{ max: this.state.today, format: "MM/dd/yyyy" }}
                  onKeyDown={(e) => {
                    this.onSearchKeyDown(e);
                  }}
                  // className={classes.dateInputClass}
                />
              </div>

              <div>
                <TextField
                  name="toDate"
                  id="toDate"
                  type="date"
                  value={this.state.toDate}
                  label={t("TO_DATE")}
                  InputLabelProps={{
                    shrink: true,
                  }}
                  variant={"outlined"}
                  size={"small"}
                  onChange={(e) => {
                    this.onChange(e);
                  }}
                  inputProps={{
                    max: this.state.today,
                    min: this.state.fromDate,
                    format: "MM/dd/yyyy",
                  }}
                  onKeyDown={(e) => {
                    this.onSearchKeyDown(e);
                  }}
                  // className={classes.dateInputClass}
                />
              </div>

              {/* <div className={classes.searchOrderLabelOuter}>
                                <div className={classes.searchOrderLabelInner}> */}
              <div style={{ display: "flex", alignItems: "flex-start" }}>
                <Tooltip title={t("SEARCH")}>
                  <IconButton
                    className="iconButtonSecondary"
                    onClick={this.filterTable}
                  >
                    <SearchIcon />
                  </IconButton>
                </Tooltip>{" "}
                &nbsp;
                <Tooltip title={t("CLEAR")}>
                  <IconButton
                    className="iconButtonSecondary"
                    onClick={this.clearFilters}
                  >
                    <ClearIcon />
                  </IconButton>
                </Tooltip>{" "}
                &nbsp;
                <Tooltip title={t("REFRESH")}>
                  <IconButton
                    className="iconButtonSecondary"
                    onClick={this.refreshTableSearch}
                  >
                    <RefreshIcon />
                  </IconButton>
                </Tooltip>
              </div>
              {/* </div> */}
            </div>
            <SettlementTable
              list={this.state.settlementList}
              rowsPerPage={this.state.rowsPerPage}
              totalSettlementCount={this.state.totalSettlementCount}
              page={this.state.page}
              handleChangePage={this.handleChangePage}
              handleChangeRowsPerPage={this.handleChangeRowsPerPage}
              sortBy={this.state.sortBy}
              sortOrder={this.state.sortOrder}
              updateSorting={this.updateSorting}
              // convertDate={this.convertDate}
              isValidDate={this.isValidDate}
              providerType={this.props.providerType}
              tenantRoles={this.props.tenantRoles}
            />
          </Paper>
          <Loader loading={this.state.loading} />
        </main>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    loggedInUserId: state.auth.loggedInUserId,
    loggedInUserType: state.auth.userLoginType,
    providerType: state.auth.providerType,
    tenantRoles: state.auth.tenantRoles,
  };
};

// Set data to redux store
const mapDispatchToProps = (dispatch) => {
  return {
    setErrorMessage: (errMsg, msgType) =>
      dispatch({ type: actionTypes.SET_ERROR_MSG, errMsg, msgType }),
    setCompDidMount: () =>
      dispatch({ type: actionTypes.GLOBAL_COMP_DID_MOUNT }),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withTranslation("translations")(Settlement));
